import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './css/AddCaptain.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
// import captain_json from './js/captains.json'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import { DBContext } from './DBContext'

function AddTax() {

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const { logginedDB } = useContext(DBContext);

    const location = useLocation()

    const [tax, setTax] = useState({})
    const [saving, setSaving] = useState(false)

    //('tax', tax);


    // useEffect(() => {
    //     if (location.state) {
    //         setUserDetails(location.state.userDetails)
    //         setUType(location.state.type)
    //     }
    // },[location])


    const navigate = useNavigate(null)

    const handleSavebutton = async () => {
        if (saving) return;
        setSaving(true);
        console.log(tax, "tax")
        if ( !tax.cgst  || !tax.gName  ||
            !tax.gstpercent  || !tax.sgst ) {
            return alert("Make sure all fields are filled")
        }
        if (!tax.sdate || !tax.edate || tax.sdate >= tax.edate) {
            return alert("Please Check Start date and End data")
        }
        try {
            const response = await fetch(`${apiBaseUrl}/addTaxGroups/${logginedDB}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(tax),
            });

            if (response.status === 200) {
                //("200");
                
                toast.success(`Tax Groups Added!`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
                navigate('/basemenureg', {
                    state: 'taxCancel'
                })
            } else if (response.status === 409) {
                //("409");
                
                toast.success(`Tax group already exists!!`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
            } else {
                toast.success(`Something went wrong. Please try again!!`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
            }
        } catch (error) {
            toast.success(`Something went wrong. Please try again!!`, {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        } finally {
            setSaving(false);
        }
    }
    const toNavigateback = () => {
        navigate('/basemenureg', {
            state: 'taxCancel'
        })
    }

    // const handleTax = (e, field) => {
    //     const val = e.target.value
    //     setTax(prev => ({
    //         ...prev,
    //         [field]: val
    //     }))
    // }

    const handleTax = (e, field) => {
        const val = e.target.value;
      
        if (field === 'gstpercent') {
          const dividedValue = (parseFloat(val) || 0) / 2;
      
          setTax(prev => ({
            ...prev,
            gstpercent: val,
            sgst: dividedValue.toFixed(2),
            cgst: dividedValue.toFixed(2)
          }));
        } else {
          setTax(prev => ({
            ...prev,
            [field]: val
          }));
        }
      };
      

    return (
        <div className='TableRegMainDiv'>
            <SherDineNav />
            <div className='w-full bg-[#f5f5f5] flex gap-3 h-full'>
                <div className='w-max h-full z-[9999]'>
                    <SideNav focus={'User'} />
                </div>
                <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3'>
                    <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                        <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Taxes'} />
                    </div>
                    <div className='w-full h-full flex flex-col gap-3 relative'>
                        <div className='w-full h-max flex bg-[#fff] p-2 text-[1rem] font-nunito'>
                            <span className='w-1/2 font-[600] flex justify-start items-center'>Add Tax Group</span>
                            <div className='w-1/2 font-[500] flex justify-end items-center gap-3'>
                                <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none' onClick={toNavigateback}>Cancel</button>
                                <button className={`bg-[#0008B4] text-[#fff] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none ${saving ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={handleSavebutton} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                            </div>
                        </div>
                        <div className='bg-[#fff] p-3 h-full flex flex-col gap-3' id="contentContainer">
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>Tax Group Name</span>
                                    <input type="text" value={tax.gName} onChange={(e) => handleTax(e, 'gName')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>GST %</span>
                                    <input type="number" value={tax.gstpercent} onChange={(e) => handleTax(e, 'gstpercent')} />
                                </div>
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>SGST</span>
                                    <input type="number" value={tax.sgst} onChange={(e) => handleTax(e, 'sgst')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>CGST</span>
                                    <input type="number" value={tax.cgst} onChange={(e) => handleTax(e, 'cgst')} />
                                </div>
                                {/* <div className='Reg_input_div'>
                                    <span>IGST</span>
                                    <input type="number" value={tax.igst} onChange={(e) => handleTax(e, 'igst')} />
                                </div> */}
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>SDate</span>
                                    <input type="date" value={tax.sdate} onChange={(e) => handleTax(e, 'sdate')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>EDate</span>
                                    <input type="date" value={tax.edate} onChange={(e) => handleTax(e, 'edate')} />
                                </div>
                            </div>
                            {/* <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>Confirm Password</span>
                                    <input type="password" value={captain.UserPassword} onChange={(e) => handleCaptain(e,'UserPassword')} />
                                </div>
                                <div className='Reg_input_div'>
                                    <span>Swipe Code</span>
                                    <input type="text" value={userDetails ? userDetails.swipeCode : captain.SwipeCode} onChange={(e) => handleCaptain(e,'SwipeCode')} />
                                </div>
                            </div> */}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AddTax
